// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import FeedbackPage from './pages/FeedbackPage';
import DashboardPage from './pages/DashboardPage';
import ScanSelectionPage from './pages/ScanSelectionPage';
import AboutUsPage from './pages/AboutUsPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app-container">
        <Header /> {/* Add this line */}
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/feedback" element={<FeedbackPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/dashboard/:scanType" element={<DashboardPage />} />
            <Route path="/ScanSelectionPage" element={<ScanSelectionPage />} />
            <Route path="/AboutUsPage" element={<AboutUsPage />} />
            
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;